import { userConstants } from "../constantes/userConstants";
import { userService } from "../servicios/userService";
import { alertActions } from "./alertActions";
import { history } from "../helpers/history";
import { organizacionesHelper } from "../helpers/organizacionesHelper";
import { ApiRest } from "react-comun-seps/lib/api/ApiRest";
import { datosLocalesHelper } from "react-comun-seps/lib/helpers/datosLocalesHelper";
import { v4 as uuidv4 } from "uuid";

export const userActions = {
  login,
  logout,
  getSistemas,
  seleccionaSistema,
  getOrganizaciones,
  seleccionaOrganizacion,
  getMenuPrincipal,
  validar,
  confirmaClaveNueva,
  verAcuerdo,
};

function login(username, password) {
  return (dispatch) => {
    dispatch(request({ username }));
    userService.login(username, password).then(
      (user) => {
        dispatch(success(user));
        history.push("/acuerdos");
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function validar(usuario, correoelectronico) {
  return (dispatch) => {
    dispatch(request({ usuario }));
    userService.validacion(usuario, correoelectronico).then((respuesta) => {
      if (!respuesta) {
        dispatch(
          alertActions.success(
            "Su solicitud fué procesada satisfactoriamente, por favor verifique su correo para continuar con el proceso"
          )
        );
      } else {
        dispatch(alertActions.error(respuesta));
      }
    });
  };
  function request(respuesta) {
    return { type: userConstants.LOGIN_REQUEST, respuesta };
  }
  function success(respuesta) {
    return { type: userConstants.LOGIN_SUCCESS, respuesta };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function validaTicketAction(ticket) {
  return (dispatch) => {
    dispatch(request({ ticket }));
    userService.validaTicket(ticket).then((respuesta) => {
      if (!respuesta) {
        dispatch(alertActions.success("Ticket validado satisfactoriamente"));
      } else {
        dispatch(alertActions.error(respuesta));
      }
    });
  };
  function success(respuesta) {
    return { type: userConstants.SISTEMAS_SUCCESS, respuesta };
  }
  function request(respuesta) {
    return { type: userConstants.CONFIRMATICKET_REQUEST, respuesta };
  }
}

function confirmaClaveNueva(usuario, contrasenia, ticket) {
  return (dispatch) => {
    dispatch(request({ usuario }));
    userService.actualizaClave(usuario, contrasenia, ticket).then((respuesta) => {
      if (!respuesta) {
        dispatch(
          alertActions.success(
            "La contraseña fue actualizada satisfactoriamente, intente loguearse nuevamente"
          )
        );
      } else {
        dispatch(alertActions.error(respuesta));
      }
    });
  };
  function request(respuesta) {
    return { type: userConstants.CONFIRMARCLAVE_REQUEST, respuesta };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getAcuerdos() {
  let userDecode = datosLocalesHelper();
  let user = userDecode.tokenSeps.idusuario;
  return (dispatch) => {
    userService.acuerdos(user).then((acuerdos) => {
      if (acuerdos) {
        dispatch(alertActions.success("si hay"));
        dispatch(success(acuerdos));
      } else {
        dispatch(alertActions.error(acuerdos));
      }
    });
  };
  function success(acuerdos) {
    return { type: userConstants.ACUERDOS_SUCCESS, acuerdos };
  }
}

function verAcuerdo(idAcuerdo) {
  return (dispatch) => {
    userService.verAcuerdo(idAcuerdo).then((acuerdo) => {
      if (acuerdo) {
        dispatch(success(acuerdo));
      } else {
        dispatch(alertActions.error(acuerdo));
      }
    });
  };
  function success(acuerdo) {
    return { type: userConstants.ACUERDO_SUCCESS, acuerdo };
  }
}

function getSistemas() {
  let userDecode = datosLocalesHelper();
  let user = userDecode.tokenSeps.idusuario;
  return (dispatch) => {
    dispatch(request(user));
    userService.sistemas(user).then(
      (sistemas) => {
        ApiRest.guardarDatoLocal("nsistemasSeps", Object.keys(sistemas).length);
        if (Object.keys(sistemas).length) {
          if (Object.keys(sistemas).length === 1) {
            dispatch(this.seleccionaSistema(sistemas[0]));
          } else {
            dispatch(success({ user: userDecode, sistemas: sistemas }));
          }
        } else {
          dispatch(failure("Usuario no tiene accesos"));
          dispatch(alertActions.error("Usuario no tiene accesos"));
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
    //history.push('/sistemas');
  };
  function request(user) {
    return { type: userConstants.SISTEMAS_REQUEST, user };
  }
  function success(sistemas) {
    return { type: userConstants.SISTEMAS_SUCCESS, sistemas };
  }
  function failure(error) {
    return { type: userConstants.SISTEMAS_FAILURE, error };
  }
}

function seleccionaSistema(sistema) {
  const { tokenSeps } = datosLocalesHelper();
  return (dispatch) => {
    userService.subsistemas(sistema, tokenSeps).then((subsistemas) => {
      let subsistema = subsistemas[0];
      let codAcceso = uuidv4();
      if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        codAcceso = crypto.randomUUID();
      }
      let sistemaSeleccionado = {
        codSistema: subsistema.codSistema,
        codSistemaPadre: sistema.codSistema,
        nomNombre: subsistema.nomNombre,
        url: subsistema.txtUrl,
        codAcceso: codAcceso,
      };
      ApiRest.guardarDatoLocal("sistemaSeps", JSON.stringify(sistemaSeleccionado));
      dispatch(seleccion(datosLocalesHelper()));
      history.push("/organizaciones");
    });
  };
  function seleccion(sistema) {
    return { type: userConstants.SISTEMA_SELECCIONADO, sistema };
  }
}

function getOrganizaciones() {
  let userDecode = datosLocalesHelper();
  return (dispatch) => {
    dispatch(request());
    userService.organizaciones(userDecode.tokenSeps, userDecode.sistemaSeps).then(
      (organizaciones) => {
        let organizacionesSeps = organizacionesHelper(organizaciones);
        let totalOrg =
          organizacionesSeps.organizacionEps.length + organizacionesSeps.organizacionSfps.length;
        ApiRest.guardarDatoLocal("norgSeps", totalOrg);
        if (totalOrg) {
          if (totalOrg === 1) {
            if (organizacionesSeps.organizacionEps.length) {
              dispatch(this.seleccionaOrganizacion(organizacionesSeps.organizacionEps[0]));
            } else {
              dispatch(this.seleccionaOrganizacion(organizacionesSeps.organizacionSfps[0]));
            }
          } else {
            dispatch(success({ sistema: userDecode, organizaciones: organizacionesSeps }));
          }
        } else {
          dispatch(this.getMenuPrincipal());
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
    //history.push('/organizaciones');
  };
  function request() {
    return { type: userConstants.ORGANIZACIONES_REQUEST };
  }
  function success(organizaciones) {
    return { type: userConstants.ORGANIZACIONES_SUCCESS, organizaciones };
  }
  function failure(error) {
    return { type: userConstants.ORGANIZACIONES_FAILURE, error };
  }
}

function seleccionaOrganizacion(organizacion) {
  return (dispatch) => {
    ApiRest.guardarDatoLocal("orgSeps", JSON.stringify(organizacion));
    dispatch(this.getMenuPrincipal());
  };
}

function getMenuPrincipal() {
  return async (dispatch) => {
    dispatch(request(datosLocalesHelper()));
    let organizacion = JSON.parse(ApiRest.obtenerDatoLocal("orgSeps")) || {};
    await crearSistema(organizacion);
    history.push("/inicio");
  };
  function request(sistema) {
    return { type: userConstants.MENUPRINCIPAL_REQUEST, sistema };
  }
}

async function crearSistema(organizacion) {
  let userDecode = datosLocalesHelper() || {};

  let data = {
    usuario: userDecode ? userDecode.tokenSeps.sub : null,
    sessionId: userDecode ? userDecode.sessionId : null,
    accesoGenerado: userDecode.sistemaSeps.codAcceso,
    codOrganizacion: organizacion.codOrganizacion || null,
    codOrganizacionUsuario: organizacion.codOrganizacionUsuario || null,
    codSistema: userDecode.sistemaSeps.codSistemaPadre,
    codSubsistema: userDecode.sistemaSeps.codSistema,
  };
  return await userService.crearSistema(data);
}
